<template>
  <el-dialog
      :visible.sync="visible"
      title="生产合同费用设置"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <div style="display: flex;justify-content: space-between;align-items: center">
        <el-button type="primary" size="mini" @click="addCharge">添加费用</el-button>
        <div style="display: flex;align-items: center">常用费用项：
          <el-tag type="primary" style="margin-right: 10px;">包装检品</el-tag>
          <el-tag type="primary" style="margin-right: 10px;">纸箱</el-tag>
          <el-tag type="primary" style="margin-right: 10px;">中棉</el-tag>
          <el-tag type="primary" style="margin-right: 10px;">运费</el-tag>
        </div>
      </div>
      <SweetTable :data="dataForm.chargeList" :is-page="false" :summaries-column="['amount']" :height="500">
        <el-table-column
            header-align="center"
            align="center"
            label="费用名称"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'chargeList.' + scope.$index + '.name'"
                :rules="detailRule.name" style="margin-bottom: 0px;"
                label-width="0">
              <el-autocomplete
                  size="mini" style="width: 100%;"
                  v-model="scope.row.name"
                  placeholder="请输入费用名称"
                  :fetch-suggestions="nameSearcher"
                  @select="item=>{scope.row.name=item.value}"
              ></el-autocomplete>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            width="140"
            prop="amount"
            label="金额"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'chargeList.' + scope.$index + '.amount'"
                :rules="detailRule.amount" style="margin-bottom: 0px;"
                label-width="0">
              <el-input
                  size="mini"
                  v-model="scope.row.amount"
                  placeholder="请输入金额"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            width="140"
            prop="optDate"
            label="费用时间"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'chargeList.' + scope.$index + '.optDate'"
                style="margin-bottom: 0px;"
                label-width="0">
              <el-date-picker
                  v-model="scope.row.optDate"
                  type="date" size="mini" value-format="yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            label="备注"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'chargeList.' + scope.$index + '.remark'" style="margin-bottom: 0px;"
                label-width="0">
              <el-input
                  size="mini"
                  v-model="scope.row.remark"
                  placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            width="100"
            label="操作"
        >
          <template slot-scope="scope">
            <el-button
                type="text"
                icon="el-icon-remove"
                size="mini"
                @click="delRow(scope.$index, scope.row, 'chargeList')"
            >移除
            </el-button>
          </template>
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <el-button size="mini" @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button size="mini" type="primary" @click="dataFormSubmitHandle()">{{$t('confirm')}}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import MakeChargeService from '@/service/make/MakeChargeService'
import { isNumber, moneyValidator } from '@/utils/validate'
import debounce from 'lodash/debounce'

export default {
  name: 'charge-dialog',
  data () {
    return {
      visible: false,
      dataForm: {
        makeId: '',
        chargeList: []
      },
      detailRule: {
        name: [{ required: true, message: '请填写名称', trigger: 'change' }],
        amount: [
          { required: true, message: '请填写正确的金额', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' },
        ]
      },
      dataRule: {}
    }
  },
  methods: {
    async nameSearcher (queryString, cb) {
      const data = await MakeChargeService.queryNames(this.dataForm.makeId, queryString)
      const suggestData=data.map(item=>{return {value:item}})
      cb(suggestData)
    },
    delRow (index, row, dataKey) {
      if (this.dataForm[dataKey]) {
        this.dataForm[dataKey].splice(index, 1)
      }
    },
    //添加费用
    addCharge () {
      this.dataForm.chargeList.push({
        id: null,
        name: '',
        amount: null,
        remark: ''
      })
    },
   async init (makeId) {
      this.dataForm.makeId = makeId
     this.dataForm.chargeList=await  MakeChargeService.queryList(this.dataForm.makeId)
      this.visible = true
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }
            let postForm = {
              id: this.dataForm.makeId,
              chargeList: this.dataForm.chargeList
            }
            this.$api2.post('/erp/make/charge/save', postForm).then(res => {
              this.$emit('changed')
              this.$c.success(this.$t('prompt.success')).then(() => {
                this.visible=false
              })
            }).catch(() => {
            })
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
  }
}
</script>

<style scoped>

</style>
